import script from "./CollapsiblePropertyPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsiblePropertyPerformance.vue?vue&type=script&setup=true&lang=js"

import "./CollapsiblePropertyPerformance.vue?vue&type=style&index=0&id=5ffe0980&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffe0980"]])

export default __exports__